module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACtJREFUeNpiZGBg+M9AAfgPBCACxO4ghc1Eia2MUGd3jjp71NnDzNkAAQYA9LOsNBe9wf8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/img/overlays/09.png
// module id = ../../../../../img/overlays/09.png
// module chunks = styles